import { render, staticRenderFns } from "./OrderVideoCourseDetail.vue?vue&type=template&id=6d0b4a9c&scoped=true"
import script from "./OrderVideoCourseDetail.vue?vue&type=script&lang=js"
export * from "./OrderVideoCourseDetail.vue?vue&type=script&lang=js"
import style0 from "./OrderVideoCourseDetail.vue?vue&type=style&index=0&id=6d0b4a9c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6d0b4a9c",
  null
  
)

export default component.exports